const demo_app = {
    notification: '체험 App에 로그인 하기 위해 관리자 정보 또는 게정을 새로 생성하여 로그인해보세요.',
    title: '성공적으로 체험 App에 로그인되었어요!',
    subtitle: '여기 로그인 정보가 있어요:',
    username: '사용자 이름: ',
    user_id: '사용자 ID: ',
    sign_out: '체험 App 로그아웃',
    continue_explore: '또는 계속해서 살펴보기',
    customize_sign_in_experience: '로그인 경험 커스터마이징',
    enable_passwordless: 'Passwordless 활성화',
    add_social_connector: '소셜 Connector 추가',
};
export default demo_app;
